// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"B--z","refreshPageWarning":"C--z","redirectMessageText":"D--z"};